import api from './api';
import type { Review, PaginatedResult } from '../types';

export const feedService = {
  async getDiscoverFeed(page = 1, pageSize = 10): Promise<PaginatedResult<Review>> {
    const response = await api.get<PaginatedResult<Review>>('/feed/discover', {
      params: { page, pageSize },
    });
    return response.data;
  },

  async getFollowingFeed(page = 1, pageSize = 10): Promise<PaginatedResult<Review>> {
    const response = await api.get<PaginatedResult<Review>>('/feed/following', {
      params: { page, pageSize },
    });
    return response.data;
  },
};
